import { useEffect } from 'react'
import { Box, darken, Divider, List, Typography } from '@material-ui/core'

import styled from 'styled-components'
import { keyboard } from '../../input/keyboard'
import { shape, theme } from '../../theme'

import PageLink from './PageLink'
import { Route, Switch, Redirect } from 'react-router-dom'
import IntroductionPage from './pages/IntroductionPage'
import ElementsPage from './pages/ElementsPage'
import SandboxPage from './pages/SandboxPage'
import ControlsPage from './pages/ControlsPage'
import WASDMovement from './pages/WASDMovement'
import ClonePage from './pages/ClonePage'
import SubstitutionPage from './pages/SubstitutionPage'

const RootWrapper = styled.div`
	display: flex;
	flex-direction: column;
	position: absolute;
	inset: 0;
	background: ${darken(theme.palette.background.default, 0.12)};
	gap: 3rem;
	align-items: stretch;
	padding: 5rem;
`



const Bracket = styled.span`
	font-size: 0.6em;
`

export default function GameView() {

	useEffect(() => {

		const handleKeyDown = (e: any) => {
			if (e.key === 'Shift') {
				keyboard.shiftDown = true
			} else if (e.key === 'Alt') {
				keyboard.altDown = true
			} else if (e.key === 'Control') {
				keyboard.ctrlDown = true
			}
		}

		const handleKeyUp = (e: any) => {
			if (e.key === 'Shift') {
				keyboard.shiftDown = false
			} else if (e.key === 'Alt') {
				keyboard.altDown = false
			} else if (e.key === 'Control') {
				keyboard.ctrlDown = false
			}
		}

		document.addEventListener('keydown', handleKeyDown)
		document.addEventListener('keyup', handleKeyUp)

		return () => {
			document.removeEventListener('keydown', handleKeyDown)
			document.removeEventListener('keyup', handleKeyUp)
		}
	}, [])

	return (
		<RootWrapper>
			<Box display="flex" justifyContent="space-between">
				<Box display="flex" gridGap="10px" flexDirection="column">
					<Typography variant="h4" align="center" color="primary" style={{ fontSize: '60px', fontFamily: 'monospace', display: 'flex', alignItems: 'center' }}>
						Ma<Bracket>[</Bracket>g<Bracket>]</Bracket>estro✨
					</Typography>
					<Typography variant="subtitle2" color="textSecondary">Flexible Magic system Proof of Concept</Typography>
				</Box>
				<Box display="flex" flexDirection="column" justifyContent="flex-end">
					<Typography align="right">Created and thought out by <b>Tomer Atar</b> 🧙‍♂️</Typography>
					<Typography align="right">contact <b>kenyweb7@gmail.com</b> 📫</Typography>
				</Box>
			</Box>

			<Box display="flex" gridGap="4rem" width="100%" height="100%" flex="1">

				{/* Left nav bar */}
				<Box>
					<Box
						display="flex"
						alignItems="center"
						justifyContent="space-evenly"
						gridGap="10px"
						border={`1px solid ${theme.palette.divider}`}
						p="4px 8px"
						borderRadius={shape.borderRadius}
						marginBottom="8px"
					>
						💡
						<Box fontSize="12px" color="text.secondary">middle click links<br />to open in a new tab</Box>
					</Box>
					<List style={{ padding: 0 }}>
						<PageLink icon="📘" text="Introduction" />
						<PageLink icon="⌨" text="Controls" />
						<PageLink icon="🔥" text="Elements" />
						<Divider style={{ margin: "8px 0" }} />
						<PageLink icon="📃" text="WASD Movement" />
						<PageLink icon="📃" text="Clones" />
						<PageLink icon="📃" text="Substitution" />
						<PageLink icon="🛠" text="Sandbox" />
					</List>
				</Box>

				{/* content area */}
				<Box display="flex" flex="1" maxHeight="70vh">

					<Switch>
						<Route path="/Introduction">
							<IntroductionPage />
						</Route>

						<Route path="/Controls">
							<ControlsPage />
						</Route>

						<Route path="/Elements">
							<ElementsPage />
						</Route>

						<Route path="/WASD_Movement">
							<WASDMovement />
						</Route>

						<Route path="/Clones">
							<ClonePage />
						</Route>
						<Route path="/Substitution">
							<SubstitutionPage />
						</Route>

						<Route path="/Sandbox">
							<SandboxPage />
						</Route>

						<Redirect to='/Introduction' />
					</Switch>
				</Box>

			</Box>
		</RootWrapper>
	)
}
